import React, { Component } from 'react';
import {
  List,
  Button,
  Header,
  Segment,
  Message,
  Loader,
  Modal,
  Confirm,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Avatar from '../../../components/avatar/avatar';
import {
  fetchBlockedUsers,
  unblockUser,
} from '../../../modules/user';
import { authUtil } from '../../../utils';

class BlockedUsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unblockingUserId: null,
      showUnblockConfirm: false,
    };
  }

  componentDidMount() {
    const { userProfile, idToken } = this.props;
    if (userProfile && userProfile._id && idToken) {
      this.props.fetchBlockedUsers(idToken, userProfile._id);
    }
  }

  componentDidUpdate(prevProps) {
    const { userProfile, idToken } = this.props;
    if (
      userProfile &&
      userProfile._id &&
      idToken &&
      (!prevProps.userProfile || prevProps.userProfile._id !== userProfile._id)
    ) {
      this.props.fetchBlockedUsers(idToken, userProfile._id);
    }
  }

  handleUnblockClick = userId => {
    this.setState({
      unblockingUserId: userId,
      showUnblockConfirm: true,
    });
  };

  handleUnblockConfirm = async () => {
    const { unblockingUserId } = this.state;
    const { userProfile, idToken } = this.props;
    const { t } = this.props;

    if (!unblockingUserId || !userProfile || !idToken) {
      return;
    }

    this.setState({ showUnblockConfirm: false });
    this.props.unblockUser(idToken, unblockingUserId, userProfile._id, () => {
      this.setState({ unblockingUserId: null });
    });
  };

  handleUnblockCancel = () => {
    this.setState({
      showUnblockConfirm: false,
      unblockingUserId: null,
    });
  };

  render() {
    const { blockedUsers, t, userProfile } = this.props;
    const { unblockingUserId, showUnblockConfirm } = this.state;

    if (!userProfile) {
      return null;
    }

    // Handle both array of IDs (strings) or array of user objects
    const blockedUserToUnblock = blockedUsers.find(user => {
      if (typeof user === 'string') {
        return user === unblockingUserId;
      }
      return user && (user._id === unblockingUserId || user === unblockingUserId);
    });
    
    // Get user ID for display/unblock action
    const getUserId = (user) => {
      if (typeof user === 'string') {
        return user;
      }
      return user && user._id;
    };
    
    // Get user display name
    const getUserDisplayName = (user) => {
      if (typeof user === 'string') {
        return user; // Just show the ID if we don't have user info
      }
      return user && (user.displayName || user.email || t('UnknownUser'));
    };

    return (
      <>
        <Segment clearing>
          <Header content={t('BlockedUsers')} icon="ban" />
          {blockedUsers.length === 0 ? (
            <Message info>
              <Message.Content>{t('NoBlockedUsers')}</Message.Content>
            </Message>
          ) : (
            <List divided relaxed>
              {blockedUsers.map((user, index) => {
                const userId = getUserId(user);
                const displayName = getUserDisplayName(user);
                const key = typeof user === 'string' ? user : (user._id || index);
                
                return (
                  <List.Item key={key}>
                    <List.Content floated="right">
                      <Button
                        size="small"
                        negative
                        onClick={() => this.handleUnblockClick(userId)}
                      >
                        {t('UnblockUser')}
                      </Button>
                    </List.Content>
                    <List.Content>
                      <List.Header style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar
                          name={displayName}
                          src={typeof user === 'object' ? user.photoUrl : undefined}
                          diameter={30}
                        />
                        <span style={{ marginLeft: '1em' }}>
                          {displayName}
                        </span>
                      </List.Header>
                    </List.Content>
                  </List.Item>
                );
              })}
            </List>
          )}
        </Segment>

        <Confirm
          open={showUnblockConfirm}
          header={t('UnblockUser')}
          content={
            blockedUserToUnblock
              ? t('UnblockUserConfirmation', {
                  _name: getUserDisplayName(blockedUserToUnblock),
                })
              : t('UnblockUserConfirmation', { _name: t('UnknownUser') })
          }
          confirmButton={t('UnblockUser')}
          cancelButton={t('Cancel')}
          onConfirm={this.handleUnblockConfirm}
          onCancel={this.handleUnblockCancel}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  userProfile: state.user.userProfile,
  idToken: state.user.idToken,
  blockedUsers: state.user.blockedUsers || [],
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchBlockedUsers,
      unblockUser,
    },
    dispatch
  );

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(BlockedUsersList)
);

